<template>
  <div class="app-container">
    <div class="card">
    <a-space class="action-space" direction="vertical" :size="12">

      <a-select
        v-model:value="algoId"
        style="width:100%"
        placeholder="选择算法"
      >
        <a-select-option 
          v-for="algorithm in algorithms" 
          :key="algorithm.id" 
          :value="algorithm.id"
        >
          {{ algorithm.name }}
        </a-select-option>
      </a-select>

      <a-range-picker
        style="width:100%"
        :presets="rangePresets"
        v-model="dateRange"
        :default-value="defaultDateRange"
        @change="handleRangeChange" />

      <a-select
        v-model:value="selectedLeagueId"
        style="width:100%"
        placeholder="选择联赛"
      >
        <a-select-option 
          v-for="league in leagues" 
          :key="league.leagueId" 
          :value="league.leagueId"
        >
          {{ league.leagueName }}
        </a-select-option>
      </a-select>
      
      <!-- <a-select
        v-model:value="selectedUserId"
        v-if="userId == 1"
        style="width:100%"
        placeholder="选择用户"
      >
        <a-select-option 
          v-for="user in users" 
          :key="user.user_id" 
          :value="user.user_id"
        >
          {{ user.info }}
        </a-select-option>
      </a-select> -->

      <!-- <a-space class="spacing">
        筛选：
        <a-checkbox
          v-model:checked="leagueSelectAll"
          :indeterminate="leagueSelectionIndeterminate"
          @change="onCheckAllChange"
          >
          全选
        </a-checkbox>
        <div class="league-list">
          <a-space class="league-space">
            <a-checkbox v-for="league in leagues" :key="league.leagueId" :value="league.leagueId" :checked="leagueSelected.includes(league.leagueId)" @change="onLeagueSelecttionChange(league.leagueId)">{{ league.leagueName }}</a-checkbox>
          </a-space>
        </div>
      </a-space> -->

      <!-- 球队选择表格 -->
      <div class="team-selection-table" v-if="selectedLeagueTeams.length > 0">
        <a-table
          :columns="teamColumns"
          :data-source="selectedLeagueTeams"
          :pagination="false"
          row-key="name"
          :row-selection="{
            selectedRowKeys: selectedTeams,
            onChange: (selectedRowKeys, selectedRows) => {
              this.selectedTeams = selectedRowKeys;
            },
            getCheckboxProps: (record) => ({
              value: record.name
            })
          }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'name'">
              {{ record.name }}
            </template>
          </template>
        </a-table>
        <div class="selected-info">
          已选择 {{ selectedTeams.length }} 支球队
        </div>
      </div>

      <a-space class="spacing" :size="12">
        <a-button
          :disabled="clearDisabled"
          @click="onClearUserBettings"
          >
          清除
        </a-button>
        <a-button
          @click="onVerify"
          >
          检验
        </a-button>
        <a-button
          v-if="userId == 1"
          :loading="compareLoading"
          @click="onCompare"
          >
          对比全部算法
        </a-button>
      </a-space>

      <!-- Phase 0 回测对比表格（仅管理员） -->
      <div v-if="userId == 1 && compareRows.length > 0" class="algorithm-result-table">
        <div class="selected-info">
          共 {{ compareSummary.match_count }} 场（训练/测试按时间 {{ compareSummary.split_ratio }} 切分，分界 {{ compareSummary.cutoff_time }}）
        </div>
        <a-table
          :columns="compareColumns"
          :data-source="compareRows"
          :pagination="false"
          row-key="key"
          size="small"
        />
      </div>

      <!-- 算法结果表格 -->
      <div v-if="algorithm_result && algorithm_result.length > 0" class="algorithm-result-table">
        <a-table
          :columns="resultColumns"
          :data-source="algorithm_result"
          :pagination="false"
          row-key="name"
          :expandable="{
            expandedRowRender: (record) => {
              if (record.matches && record.matches.length > 0) {
                return this.$createElement('a-table', {
                  props: {
                    columns: this.matchColumns,
                    dataSource: record.matches,
                    pagination: false,
                    size: 'small'
                  }
                });
              } else {
                return this.$createElement('div', '暂无比赛数据');
              }
            }
          }"
        >
          <template slot="win_rate" slot-scope="text, record">
            <span>{{ record.win_count }}/{{ record.total_count }}</span>
          </template>
        </a-table>
      </div>
    </a-space>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'Stats',
  meta: {
    title: '足彩助手 - 算法'
  },
  components: {
  },
  data() {
    const sevenDaysAgo = moment().subtract(7, 'days');
    const startDay = moment('2025-08-01');
    const today = moment();
    return {
      selectedUserId: '',
      selectedLeagueId: 0,
      dateRange: [startDay, today],
      defaultDateRange: [startDay, today],
      rangePresets: [
        {
          label: '7天',
          value: [moment().subtract(7, 'days'), moment()]
        },
        {
          label: '14天',
          value: [moment().subtract(14, 'days'), moment()]
        },
        {
          label: '一个月',
          value: [moment().subtract(1, 'months'), moment()]
        }
      ],
      algoId: 1,
      algo_count: 5,
      compareLoading: false,
      leagueSelectAll: false,
      leagueSelectionIndeterminate: false,
      leagueSelected: [],
      selectedTeams: [],
      teamColumns: [
        {
          title: '球队名称',
          dataIndex: 'name'
        }
      ],
      // 算法结果表格列配置
      resultColumns: [
        {
          title: '球队',
          dataIndex: 'name'
        },
        {
          title: '投入',
          dataIndex: 'money_total'
        },
        {
          title: '收益',
          dataIndex: 'money_income'
        },
        {
          title: '收益率',
          dataIndex: 'money_percent'
        },
        {
          title: '胜率',
          key: 'win_rate',
          scopedSlots: { customRender: 'win_rate' }
        }
      ],
      // 比赛详情表格列配置
      matchColumns: [
        {
          title: '比赛时间',
          dataIndex: 'playtime'
        },
        {
          title: '主队',
          dataIndex: 'host'
        },
        {
          title: '客队',
          dataIndex: 'guest'
        },
        {
          title: '投入',
          dataIndex: 'money_total'
        },
        {
          title: '收益',
          dataIndex: 'money_income'
        },
        {
          title: '收益率',
          dataIndex: 'percent'
        }
      ],
      // Phase 0 对比表列：全量/训练/测试关键指标 + 分市场收益
      compareColumns: [
        { title: '算法', dataIndex: 'name' },
        { title: '比赛数', dataIndex: 'match_count' },
        { title: '收益率%', dataIndex: 'return_percent' },
        { title: '命中率%', dataIndex: 'hit_rate' },
        { title: '盈亏', dataIndex: 'profit' },
        { title: '训练收益率%', dataIndex: 'train_return' },
        { title: '测试收益率%', dataIndex: 'test_return' },
        { title: '最差单场%', dataIndex: 'worst' },
        { title: 'crs', dataIndex: 'crs' },
        { title: 'hafu', dataIndex: 'hafu' },
        { title: 'ttg', dataIndex: 'ttg' }
      ]
    }
  },
  watch: {
    // 监听selectedLeagueTeams变化，默认选中所有球队
    selectedLeagueTeams: {
      handler(newValue) {
        // 清空并自动选中所有球队
        this.selectedTeams = newValue.map(team => team.name);
      },
      deep: true
    }
  },
  computed: {
    userId() {
      return Number(localStorage.getItem('userId'))
    },
    users() {
      // console.log("users: ", this.$store.state.verify.users)
      const filteredUsers = this.$store.state.verify.users.filter(user => user.user_id !== '1');
      // console.log("filteredUsers: ", filteredUsers)
      return filteredUsers;
    },
    firstUserId() {
      return this.users[0]?.user_id || 0;
    },
    leagues() {
      // return this.$store.state.verify.leagues
      return this.$store.state.verify.teams
    },
    algorithm_result() {
      return this.$store.state.verify.algorithm_result
    },
    compareResult() {
      return this.$store.state.verify.compare_result
    },
    compareSummary() {
      const res = this.compareResult || {};
      return {
        match_count: res.match_count || 0,
        split_ratio: res.split_ratio || '',
        cutoff_time: res.cutoff_time || ''
      };
    },
    compareRows() {
      const res = this.compareResult;
      if (!res || !res.comparison) return [];
      return res.comparison.map(c => ({
        key: c.algo_id,
        name: c.name,
        match_count: c.all.match_count,
        return_percent: c.all.return_percent,
        hit_rate: c.all.hit_rate,
        profit: c.all.profit,
        train_return: c.train.return_percent,
        test_return: c.test.return_percent,
        worst: c.all.worst_match_percent,
        crs: c.all.income_by_market.crs,
        hafu: c.all.income_by_market.hafu,
        ttg: c.all.income_by_market.ttg
      }));
    },
    algorithms() {
      return this.$store.state.verify.algorithms
    },
    selectedLeagueTeams() {
      const league = this.leagues.filter(league => league.leagueId == this.selectedLeagueId);
      console.log('selectedLeagueTeams: ', league);
      return league[0]?.teams || [];
    },
    clearDisabled() {
      return !this.$store.state.verify.enableClear
    }
  },
  methods: {
    ...mapActions('verify', ['enableClear']),
    async fetchUserData() {
      const startDate = this.dateRange[0].format('YYYY-MM-DD');
      const endDate = this.dateRange[1].format('YYYY-MM-DD');
      const params = {
          a: 'fetch',
          user_id: this.userId,
          show_user_id: this.selectedUserId,
          start_date: startDate,
          end_date: endDate
        }
      await this.$store.dispatch('verify/fetchVerifyInfo', params);
      // this.selectAllLeagues();
      // console.log("fetchUserData await return");
      this.selectedUserId = this.firstUserId;
    },
    async fetchTeams() {
      const params = {
        a: 'list',
        user_id: this.userId
      }
      await this.$store.dispatch('verify/fetchTeamsInfo', params);
      // console.log("all data: ", this.teams);
      this.selectedLeagueId = this.leagues[0]?.leagueId || 0;
    },
    fetchInitialData() {
      // console.log("Fetching initial data for Stats. userId: ", this.userId)
      // console.log("dates: ", this.dateRange, "default dates: ", this.defaultDateRange)
      // this.selectedUserId = this.userId;
      // this.fetchUserData()
      this.fetchTeams()
    },
    handleRangeChange(dates) {
      this.dateRange = dates;
      this.fetchUserData(this.selectedUserId)
    },
    onCheckAllChange(e) {
      this.leagueSelectAll = e.target.checked;
      if (e.target.checked) {
        this.leagueSelected = this.leagues.map(league => league.leagueId);
      } else {
        this.leagueSelected = [];
      }
      localStorage.setItem('leagueSelected', JSON.stringify(this.leagueSelected));
      this.leagueSelectionIndeterminate = false;
    },
    onLeagueSelecttionChange(value) {
      const index = this.leagueSelected.indexOf(value);
      if (index > -1) {
        this.leagueSelected.splice(index, 1);
      } else {
        this.leagueSelected.push(value);
      }
      localStorage.setItem('leagueSelected', JSON.stringify(this.leagueSelected));
      this.leagueSelectAll = this.leagueSelected.length === this.leagues.length;
      this.leagueSelectionIndeterminate = this.leagueSelected.length > 0 && this.leagueSelected.length < this.leagues.length;
    },
    selectAllLeagues() {
      this.leagueSelectAll = true;
      this.leagueSelected = this.leagues.map(league => league.leagueId);
      localStorage.setItem('leagueSelected', JSON.stringify(this.leagueSelected));
      this.leagueSelectionIndeterminate = false;
    },

    onClearUserBettings() {
      this.enableClear(false);
      axios.get('https://api.ip008.com/odds/verify.php?a=clear&user_id='+this.selectedUserId)
    },
    async onVerify() {
      const startDate = this.dateRange[0].format('YYYY-MM-DD');
      const endDate = this.dateRange[1].format('YYYY-MM-DD');
      const params = {
          a: 'verify',
          league_id: this.selectedLeagueId,
          algo_id: this.algoId,
          teams: this.selectedTeams,
          start_date: startDate,
          end_date: endDate
        }
      await this.$store.dispatch('verify/verifyAlgorithm', params);
      // console.log("params: ", params);
    },
    // Phase 0：对比全部算法（不传 algo_ids，后端默认对比 definitions 中的全部算法）
    async onCompare() {
      const startDate = this.dateRange[0].format('YYYY-MM-DD');
      const endDate = this.dateRange[1].format('YYYY-MM-DD');
      const params = {
        league_id: this.selectedLeagueId,
        teams: this.selectedTeams,
        start_date: startDate,
        end_date: endDate,
        split_ratio: 0.7
      };
      this.compareLoading = true;
      try {
        await this.$store.dispatch('verify/compareAlgorithms', params);
      } finally {
        this.compareLoading = false;
      }
    }
  },
  created() {
    this.fetchInitialData()
  }
}
</script>

<style scoped>
.action-space {
  width: 100%;
}

.team-selection-table {
  margin-top: 4px;
}

.algorithm-result-table {
  margin-top: 16px;
}

.selected-info {
  padding: 10px;
  background-color: var(--pitch-100);
  border-radius: var(--r-sm);
  margin-top: 8px;
  text-align: right;
  font-weight: 600;
  color: var(--pitch-900);
}
</style>
